export const IMG1 = "/images/img1.jpg";
export const IMG2 = "/images/img2.jpg";
export const IMG3 = "/images/img3.jpg";
export const IMG4 = "/images/img4.jpg";
export const HERO = "/images/hero.jpg";
export const CERT = "/images/certficat.jpg";
export const TRAINER = "/images/trainer.png";
export const TRAINER3 = "/images/trainer3.jpg";
export const LOGO = "/images/logo.png";
